module.exports = __webpack_public_path__ + "img/pic2.50ef8b56.png";